import angular from "angular";
import { AccountingData, PeriodType, Reports, PeriodDateKind } from "@salaxy/core";
import { UiHelpers } from "../../services";

/**
 * Handles user interaction for displaying accounting report
 */
export class AccountingReportDisplayController implements angular.IController {
  public static $inject = [
    "UiHelpers",
    "Reports"
  ];
  /**
   * Creates a new instance of AccountingReportDisplayController
   * @param uiHelpers - Salaxy ui helpers service.
   */
  constructor(
    private uiHelpers: UiHelpers,
    private reports: Reports

  ) { }

  /**
   * Display accounting report
   * @param refDate date
   */
  public display(refDate: string): void {
    const getAccountingData = (target: string) => this.reports.getAccountingDataForPeriod(refDate, target ?? "default", PeriodType.Month, null, PeriodDateKind.PaidAtDate);
    const data = {
      accountingData: null,
      isLoading: true,
      reader: {
        /**
         * Function to read data into given array
         * TODO: Should make interface for this or otherwise go-through.
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        read: (target: string, ruleSet: string, arr: AccountingData[], message: string): Promise<void> => {
          if (data.accountingData) {
            arr.push(data.accountingData);
          }
          return Promise.resolve();
        },
        /** Optional label for data export */
        exportLabel: null,
        /** Indicates if the export is not possible */
        disabled: () => !data.accountingData,
        /* Indicates if row is expandable */
        showExpand: true,
        /* Indicates if rows exists*/
        hasRows: () => !data.accountingData?.ledgerAccounts
      },
      loadCurrent: (targetId) => {
        data.isLoading = true;
        getAccountingData(targetId).then(accountingData => {
          data.accountingData = accountingData;
          data.isLoading = false;
        });
      }
    };
    data.isLoading = true;
    getAccountingData(null).then(accountingData => {
      data.accountingData = accountingData;
      data.isLoading = false;
    });
    this.uiHelpers.showDialog(
      "salaxy-components/modals/report/AccountingReport.html",
      null,
      data,
      null,
      "lg",
      true);
  }
}